import { kOCNTextColor } from "../constants";
import { SetCtxFont } from "../utils/SetCtxFont";
import { QColorButton } from "./QColorButton";

export class QAdvFillColorButton extends QColorButton {
  constructor() {
    super();
    this.fName = null;
  }

  InitAdvButton(butName) {
    this.fName = butName;
  }

  RenderInterior(drawBuffer, disabled) {
    var ctx = drawBuffer.getContext("2d");
    if (!disabled) {
      var txtFillStyle = kOCNTextColor;
      ctx.fillStyle = txtFillStyle;
      SetCtxFont(ctx, "11px Verdana");
      var txt = this.fName; // "No Fill";
      var txtDim = ctx.measureText(txt); // Optimize this later (measure)
      var txtWidth = Math.ceil(txtDim.width);
      var txtHOffset = (this.fWidth - txtWidth) / 2;

      var txtHeight = 8;
      var txtVOffset = (this.fHeight - txtHeight) / 2;
      ctx.fillText(
        txt,
        this.fHorzOffset + txtHOffset,
        this.fVertOffset + this.fHeight - txtVOffset
      );
    }
  }
}
